import {ApiClient} from '@hconnect/apiclient'
import {useQuery, useQueryClient, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {mapShiftEvent} from '../mappers'
import {EventSearchResult, SapStatusCode, ShiftEvent, ShiftEventDto} from '../types'

import {EventsSearchQueryKey} from './useEventsSearchApi'

export const QueryKey = 'events-affiliate'
const INTERVAL_PERIOD_IN_MS = 30000

type UseEventParams = {
  plantId: string
  timezone: string
  eventId: string
}

type Options = Omit<UseQueryOptions<ShiftEvent, AxiosError>, 'initialData' | 'queryKey'>

export const useAffiliateEvent = (
  {plantId, timezone, eventId}: UseEventParams,
  options?: Options
) => {
  const queryClient = useQueryClient()
  const path = `/shifthandover/${plantId}/events-affiliate/${eventId}`

  return useQuery<ShiftEvent, AxiosError>({
    queryKey: [QueryKey, eventId, plantId, timezone],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ShiftEventDto>(path, {signal})
      return mapShiftEvent(response.data, timezone)
    },
    refetchInterval: (query) =>
      query.state.data?.sapStatusCode === SapStatusCode.SUBMITTED ? INTERVAL_PERIOD_IN_MS : false,
    ...options,
    initialData: () => {
      return queryClient
        .getQueryData<EventSearchResult>([EventsSearchQueryKey])
        ?.events.find((event: ShiftEvent) => event.id === eventId)
    }
  })
}
